import { buildSuccessAttemptPayload } from '../buildPayloads/buildSuccessAttemptPayload.js';
export const trackSuccessAttempt = (params) => {
    return buildSuccessAttemptPayload(params);
};
//# sourceMappingURL=trackSuccessAttempt.js.map